import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DeliveryEffects, deliveryReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([DeliveryEffects]), StoreModule.forFeature(`delivery`, deliveryReducer)]
})
export class DeliveryStateModule {}
